export default function createReviewFiltersQueryString(filters) {
    let filtersQueryString = '&filters=';
    filters.map((filter, index) => {
        const lastItem = index === filters.length - 1;
        // we have to replace the comma, otherwise Spring would interpret this as list
        const filterValue = filter.value
            .replace(/,/g, '@@@')
            .replace(/Ä/g, '%C3%84')
            .replace(/Ö/g, '%C3%96')
            .replace(/Ü/g, '%C3%9C')
            .replace(/ä/g, '%C3%A4')
            .replace(/ö/g, '%C3%B6')
            .replace(/ü/g, '%C3%BC')
            .replace(/ß/g, '%C3%9F')
            .replace(/ẞ/g, '%E1%BA%9E');
        filtersQueryString += `${filter.type}%3D${filterValue}${!lastItem ? '%2C' : ''}`;
        return filtersQueryString;
    });
    return filtersQueryString;
}